import { render, staticRenderFns } from "./mercado-pago.vue?vue&type=template&id=14453ce5&"
import script from "./mercado-pago.vue?vue&type=script&lang=js&"
export * from "./mercado-pago.vue?vue&type=script&lang=js&"
import style0 from "./mercado-pago.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports